module.exports = __webpack_public_path__ + "static/media/download_img_3.d92af519.jpg";